export function hasLocationStateBooleanKey<K extends string>(
  state: unknown,
  key: K
): state is Record<string, unknown> & Record<K, boolean> {
  return (
    typeof state === "object" &&
    state !== null &&
    key in state &&
    typeof (state as Record<string, unknown>)[key] === "boolean"
  );
}
